<zbp-button-component [id]="id"
                      type="button"
                      [label]="label"
                      (clickHandler)="close()"
                      [theme]="'darkBlue'"  
                      [borderRadius]="borderRadius"
                      [iconPosition]="'top'"
                      [iconName]="zbpIconNames.x_cross">
</zbp-button-component>
